import Map from "./MapService";
import IOT from "./IOTService";
import WorkService from "./WorkService";
import Tracker from "./TrackerService";
import TrackerService from "./TrackerServiceEx";
import AdmcsmService from "./AdmcsmService";
import SmartLockService from "./SmartLockService";
import SmartScaleService from "./SmartScaleService";
import TripodService from "./TripodService";
import CameraService from "./CameraService";
import GdmsService from "./GdmsService";
import DvrService from "./DvrService";
import DeviceService from "./DeviceService";
import AdminService from "./AdminService";
import SmartScaleDeviceService from "./SmartScaleDeviceService";
import WmsService from "./WmsService";
import IotCameraService from "./IotCameraService";

const services = {
  Map,
  IOT,
  WorkService,
  Tracker,
  AdmcsmService,
  SmartLockService,
  SmartScaleService,
  TripodService,
  DvrService: new DvrService(),
  CameraService: new CameraService(),
  TrackerService: new TrackerService(),
  GdmsService: new GdmsService(),
  AdminService: new AdminService(),
  DeviceService: new DeviceService(),
  SmartScaleDeviceService,
  WmsService: new WmsService(),
  IotCameraService: new IotCameraService(),
};
export default services;
